module.exports = __webpack_public_path__ + "img/31.2aa39881.jpg";